import { useParams, Link } from 'react-router-dom';
import SEOHead from '@/components/feature/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ArticleCard from '@/components/base/ArticleCard';
import { Breadcrumb } from '@/components/base/Breadcrumb';
import { categories, getArticlesByCategory } from '@/mocks/articles';

export default function Category() {
  const { slug } = useParams<{ slug: string }>();
  const currentCategory = categories.find((c) => c.slug === slug);
  const articles = slug ? getArticlesByCategory(slug) : [];
  const catName = currentCategory?.name || '未知分类';

  return (
    <>
      <SEOHead
        title={catName}
        description={currentCategory?.description || `黑料曝光${catName}专题，汇聚最新最全的${catName}内幕信息。`}
        keywords={`${catName},黑料曝光,内幕曝光,真实事件`}
      />
      <Navbar />
      <main className="pt-20">
        <div className="w-full px-6 md:px-8 py-8 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: catName }]} />
            <div className="flex items-center gap-4 mt-4">
              {currentCategory && (
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-500">
                  <i className={`${currentCategory.icon} text-white text-lg`}></i>
                </div>
              )}
              <div>
                <h1 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                  {catName}
                </h1>
                <p className="text-sm text-foreground-500 mt-1">{currentCategory?.description}</p>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mt-6">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-50 text-foreground-600 hover:bg-background-200 border border-background-200/70'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>
        </div>

        <section className="w-full px-6 md:px-8 py-10">
          <div className="max-w-7xl mx-auto">
            {articles.length > 0 ? (
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {articles.map((article) => (
                  <ArticleCard
                    key={article.id}
                    slug={article.slug}
                    title={article.title}
                    excerpt={article.excerpt}
                    coverImage={article.coverImage}
                    category={article.category}
                    author={article.author}
                    publishedAt={article.publishedAt}
                    readCount={article.readCount}
                    tags={article.tags}
                  />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-background-100 mx-auto mb-4">
                  <i className="ri-inbox-line text-2xl text-foreground-300"></i>
                </div>
                <p className="text-foreground-500">暂无相关内容，请查看其他分类</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}